import React, { useEffect, useState } from "react";
import "./SnackbarNav.css"; // External CSS file
import logo from "../../../assets/icons/skyeairBlue.svg"
import { Link  } from "react-router-dom";
import ScrollToTopLink from "../../../Utils/ScrollToTop";
const SnackbarNav = () => {
  const [showNav, setShowNav] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      if (scrollY > 1 * viewportHeight) {
        setShowNav(true);
      } else {
        setShowNav(false);
      }
    }; 

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`snackbar-nav ${showNav ? "visible" : ""}`}>
      <div className="nav-content">
        <ScrollToTopLink to="/home"><img src={logo} alt="Logo" className="logo" /></ScrollToTopLink>
        <nav>
        {/* <ScrollToTopLink to="/">Home</ScrollToTopLink> */}
          <ScrollToTopLink to="/solutions">Solutions</ScrollToTopLink>
          <ScrollToTopLink to="/about">About Us</ScrollToTopLink>
          <ScrollToTopLink to="/media">Media & Partners</ScrollToTopLink>
          <ScrollToTopLink to="/contact">Contact Us</ScrollToTopLink>
        </nav>
      </div>
    </div>
  );
};

export default SnackbarNav;
